import { NoGeneralDetails, RefetchOnError } from '@energy-stacks/shared';
import { ChargingStationGeneralDetails } from '../ChargingStationGeneralDetails';
import { useChargingStationDetails } from '../useChargingStationDetails';

export const ChargingStationDetailsGeneralTab = () => {
  const { chargingStationDetails, isSuccess, isError, refetch } =
    useChargingStationDetails();

  return (
    <>
      {isError ? <RefetchOnError onRefetch={refetch} /> : null}
      {!chargingStationDetails && isSuccess ? (
        <NoGeneralDetails onRefetch={refetch} />
      ) : (
        <ChargingStationGeneralDetails />
      )}
    </>
  );
};
